import { render, staticRenderFns } from "./BimccSpreadsheet.vue?vue&type=template&id=3022fd36"
import script from "./BimccSpreadsheet.vue?vue&type=script&lang=js"
export * from "./BimccSpreadsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports